import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserRemove"><Path d="M12 20.5H4.5V19.5C4.5 15.3579 7.85786 12 12 12" stroke="currentColor"/><Circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M15.5 14.5L18.5 17.5M18.5 17.5L21.5 20.5M18.5 17.5L21.5 14.5M18.5 17.5L15.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUserRemove;
